import React from 'react';
export function MobileStickyButton() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48119785324714:1';
  return <a href={CHECKOUT_URL} className="fixed bottom-0 left-0 right-0 z-50 md:hidden block w-full text-center bg-green-500 hover:bg-green-400 text-white py-4 px-4 shadow-[0_-2px_10px_rgba(0,0,0,0.3)] transition-all duration-200" data-id="element-146">
      <span className="block text-lg font-black uppercase tracking-wide" data-id="element-147">
        👉 QUIERO MI MEGAPACK AHORA
      </span>
      <span className="block text-xs font-medium mt-0.5 opacity-90" data-id="element-148">
        ✅ Acceso inmediato · Garantía 30 días
      </span>
    </a>;
}